import { z } from "zod";

import { ExperienceActionTypeList } from "../../../dtos/experience-actions";
import { ExperienceDtoSchema } from "../../../dtos/experiences";

export const ExperienceActionRequestBodySchema = z.object({
  variationId: z.string().nullish(),
  updatePricesToVariation: z.boolean().optional(),
});

export type ExperienceActionRequestBodyType = z.infer<
  typeof ExperienceActionRequestBodySchema
>;

export const ExperienceActionResponseBodySchema = z.object({
  experience: ExperienceDtoSchema.nullable(),
});

export type ExperienceActionResponseBodyType = z.infer<
  typeof ExperienceActionResponseBodySchema
>;

export const ExperienceActionRequestPathParamsSchema = z.object({
  experienceId: z.string().uuid(),
  action: z.enum(ExperienceActionTypeList),
});

export type ExperienceActionRequestPathParamsType = z.infer<
  typeof ExperienceActionRequestPathParamsSchema
>;
